import React, { Component } from 'react';
import LoadingSpinner from "../Utils/LoadingSpinner";
import {Link} from "react-router-dom";

class PartnerPortal extends Component{

    state = {
        loading: true
    };

    componentDidMount() {
        this.props.simGps.getPartnerStatus(
            (success, result) => {
                if(success){
                    this.setState({loading:false, ...result})
                }else{
                    this.setState({loading:false})
                }
            }
        );
    }

    submitPartnerRequest = () => {
        this.setState({loading:true}, () => (
            this.props.simGps.submitPartnerRequest (
                (success, result) => {
                    if (success) {
                        this.setState({loading: false, ...result})
                    } else {
                        this.setState({loading: false})
                    }
                }
            )
        ));
    };

    render() {
        if (this.state.loading) {
            return (<LoadingSpinner text="Retrieving partner status ..."/>);
        } else {
            if( this.state.approved){
                return (<div>
                    <nav>
                        <ul>
                            <li>
                                <Link to="/partner/stripe_account">My bank account</Link>  Until you set it, you won't get any money
                            </li>
                            <li>
                                <Link to="/partner/transactions">My Transactions</Link>
                            </li>
                            <li>
                                <Link to="/partner/agreements">My Agreements</Link>
                            </li>
                        </ul>
                    </nav>
                </div>);
            }else{
                if( this.state.requested ){
                    return (<div>Your request is being considered</div>)
                }else{
                    return (<div>Please submit the request
                              <button onClick={this.submitPartnerRequest}>Make me the partner</button>
                           </div>)
                }
            }
        }
    }
}

export default PartnerPortal;
